import Entity from "@/services/westore/entities/entity";


class Customer extends Entity {
    static uri = '/customers';

    static search(params = {}) {
        return super.getAll(`${Customer.uri}/search`, params)
    }
}

export default Customer;